import { useEffect, useState } from 'react'
import type { Me } from '../../types'

// DashboardHeader - greeting + today's date + live clock. Mirrors the
// prototype's Dashboard header. The clock refreshes once a minute via
// setInterval; one timer for the whole header is cheap.

interface Props {
  me: Me | null | undefined
}

const DAYPART = (h: number) => (h < 12 ? 'morning' : h < 18 ? 'afternoon' : 'evening')

export function DashboardHeader({ me }: Props) {
  const [now, setNow] = useState(() => new Date())
  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 60_000)
    return () => clearInterval(t)
  }, [])

  const firstName = (me?.name ?? '').split(' ')[0] || 'there'
  const greeting = `Good ${DAYPART(now.getHours())}, ${firstName}`

  return (
    <div className="flex items-end justify-between gap-4 flex-wrap">
      <div>
        <h1 className="text-3xl mb-1">{greeting}</h1>
        <p className="text-ink-soft text-sm">
          {now.toLocaleDateString('en-GB', {
            weekday: 'long',
            day: 'numeric',
            month: 'long',
            year: 'numeric'
          })}
        </p>
      </div>
      <div className="text-right">
        <div className="font-mono text-2xl font-semibold leading-tight">
          {now.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' })}
        </div>
        <div className="text-xs text-ink-soft uppercase tracking-wide">
          NYMR · Heritage Ops
        </div>
      </div>
    </div>
  )
}
